export const validationImagePdf = (url) => /\.(pdf)$/i.test(url);
export const validationImageZip = (url) => /\.(zip|x-zip-compressed)$/i.test(url);
export const validationImage = (url) => /\.(gif|jpg|jpeg|tiff|png)$/i.test(url);